module.exports = __webpack_public_path__ + "img/ireland-logo-icon.b0cbb40c.png";